export const ContractorOfferEspdType = {
    NO: "NO",
    OPTIONAL: "OPTIONAL",
    YES: "YES"
}
